import { ImageD } from "app/data/image/image.types"
import { TranslationSelector } from "app/models/common"
import { ImageVM } from "app/models/image"
import { pipe } from "fp-ts/function"

export const toImageVXF =
  (translationSelector: TranslationSelector) =>
  (image: ImageD): ImageVM => ({
    alternateText: pipe(
      image.translations,
      translationSelector,
      (translated) => translated.alternateText
    ),
    height: image.height,
    url: image.url,
    variants: image.variants,
    width: image.width,
  })
